function appendQueryParams(path, params) {
    var idx = path.indexOf('?');
    var base = idx === -1 ? path : path.slice(0, idx);
    var existing = new URLSearchParams(idx === -1 ? '' : path.slice(idx + 1));
    var toAdd = new URLSearchParams(params);
    toAdd.forEach(function (value, key) { return existing.set(key, value); });
    return "".concat(base, "?").concat(existing.toString());
}
export default appendQueryParams;
